// jQuery has to be a real global: the vendored plugins, the page-specific
// bundles (monitoring, real_time, ...) and server-rendered .js.erb responses
// all reach for window.$ / window.jQuery.
import $ from 'jquery';
import jqueryUjsInit from 'jquery-ujs';

window.$ = window.jQuery = $;
jqueryUjsInit($);
